import React from 'react';
import PropTypes from 'prop-types';

const NewsletterTextInput = ({
    type, input, placeholder, meta, autocomplete,
}) => {
    const classes = meta.submitFailed && meta.error ? 'optin__input is-error' : 'optin__input';

    return (
        <React.Fragment>
            <input
                className={classes}
                type={type}
                id={input.name}
                placeholder={placeholder}
                autoComplete={autocomplete}
                {...input}
            />
            {meta.submitFailed && meta.error && (
                <div className="optin__error">{meta.error[0]}</div>
            )}
        </React.Fragment>
    );
};

NewsletterTextInput.defaultProps = {
    placeholder: '',
};

NewsletterTextInput.propTypes = {
    type: PropTypes.string.isRequired,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }).isRequired,
    placeholder: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool.isRequired,
        error: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
};

export default NewsletterTextInput;
